import { can, type User } from './types'

/** Leave and person-level entries need `staff`; the server sends none of it to anyone else, so the UI must not ask. */
export function mayShowWhoIsAway(user: Pick<User, 'is_admin' | 'abilities'> | null | undefined): boolean {
  return can(user as User | null | undefined, 'staff')
}

/** The people the away list shows: everyone, or only those in `onlyIds` (the viewer's supervisees). */
export function awayPopulation<P extends { id: string }>(people: P[], onlyIds?: ReadonlySet<string>): P[] {
  return onlyIds ? people.filter((p) => onlyIds.has(p.id)) : people
}

/** The toolbar carries the balance chips only on the tab that has a balance to show. */
export function balanceInToolbar(scope: string, hasBalance: boolean): boolean {
  return scope === 'own' && hasBalance
}
